import { findId } from '@/api';

const namespaced = true;

const state = {
	findUserInfo: {},
};

const getters = {
	findUserInfo(state) {
		return state.findUserInfo;
	},
};

const mutations = {
	getUserInfo(state, userInfo) {
		state.findUserInfo = userInfo || {};
	},
};

const actions = {
	getUserInfo({ commit }, payload) {
		return findId(payload)
			.then(response => {
				commit('getUserInfo', response.data.user);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
